import {CommonMessages} from '../common.messages';

export const PanelAccountsAddTradingMessages = {
    GetAvailablePlatformsFailed: {
        key: 'GetAvailablePlatformsFailed',
        message: 'Error while communication with the server. Can\'t get the available portals.'
    },
    AvailablePlatformsNotFound: {
        key: 'AvailablePlatformsNotFound',
        message: 'Error while communication with the server. Can\'t find the available portals.'
    },
    GetTradingPlatformsFailed: {
        key: 'GetTradingPlatformsFailed',
        message: 'Error while communication with the server. Can\'t get trading platforms.'
    },
    TradingPlatformsNotFound: {
        key: 'TradingPlatformsNotFound',
        message: 'Error while communication with the server. Can\'t find trading platforms.'
    },
    GetCashAccountFailed: {
        key: 'GetCashAccountFailed',
        message: 'Error while communication with the server. Unable to get trading cash account.'
    },
    CashAccountNotFound: {
        key: 'CashAccountNotFound',
        message: 'Error while communication with the server. Unable to find trading cash account.'
    },
    AccountRegistrationFailed: {
        key: 'AccountRegistrationFailed',
        message: 'Error while request to the server. Unable to register trading account.'
    },
    AccountRegistrationSucceed: {
        key: 'AccountRegistrationSucceed',
        message: 'The trading account is successfully registered.'
    },
    GetClearingAgentsFailed: {
        key: 'GetClearingAgentsFailed',
        message: 'Error while request to the server. Unable to get clearing agents.'
    },
    GetClearingAgentsNotFound: {
        key: 'GetClearingAgentsNotFound',
        message: 'Error while request to the server. Clearing agents not found.'
    },
    GetClearingAgentsActiveNotFound: {
        key: 'GetClearingAgentsActiveNotFound',
        message: 'Error while request to the server. Can\'t find active clearing agents.'
    },
    SameAccountSubType: {
        key: 'SameAccountSubType',
        message: 'The User already has trading account with this sub type.'
    },
    GetCurrenciesNotFound: {
        key: 'GetCurrenciesNotFound',
        message: 'Error while request to the server. Can\'t find currencies.'
    },
    GetBrokersFailed: {
        key: 'GetBrokersFailed',
        message: 'Error while request to the server. Unable to get brokers.'
    },
    GetBrokersNotFound: {
        key: 'GetBrokersNotFound',
        message: 'Error while request to the server. Brokers not found.'
    },
    BatchRegistrationFailed: {
        key: 'BatchRegistrationFailed',
        message: 'Batch creation failed. No accounts were created.'
    },
    BatchRegistrationRejected: {
        key: 'BatchRegistrationRejected',
        message: 'Batch creation was rejected. Check the account details and the number of accounts (2-20). No accounts were created.'
    },
    BatchRegistrationInProgress: {
        key: 'BatchRegistrationInProgress',
        message: 'A batch is already being created for this cash account. Wait for it to finish and try again.'
    },
    BatchRegistrationUnavailable: {
        key: 'BatchRegistrationUnavailable',
        message: 'Batch account creation is not available. No accounts were created.'
    },
    BatchRegistrationUnconfirmed: {
        key: 'BatchRegistrationUnconfirmed',
        message: 'The result of the batch creation could not be confirmed. Check the client\'s Accounts tab before trying again.'
    },
    ...CommonMessages
};
